// 0000-0/00
const mask = [/\d/, /\d/, /\d/, /\d/, '-', /\d/, '/', /\d/, /\d/];

export default {
    mask: mask,
    guide: false,
    keepCharPositions: true,
    placeholderChar: '\u2000',
};
